<span class="example-pizza-party" matSnackBarLabel>
  {{ message }}
</span>
<span matSnackBarActions>
  <button mat-button matSnackBarAction (click)="onNavigate()">
    {{ 'ui.open' | transloco | capitalize: 'sentenceCase' }}
  </button>
  <button mat-button matSnackBarAction (click)="snackBarRef.dismiss()">
    {{ 'ui.close' | transloco | capitalize: 'sentenceCase' }}
  </button>
</span>
